import { css } from 'lit'

export const stylesFluentTable = css`
  table.fluent {
    width: 100%;
    table-layout: fixed;
    background-color: white;
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px;
  }

  table.fluent thead tr th {
    border-bottom: 1px solid #eaeaea;
    outline: none;
    /* margin: 7px 0; */
    padding: calc(.375rem + 7px) .6875rem;
    text-align: left;
    color: rgba(0,0,0,0.55);
    white-space: nowrap;
    font-weight: 600;
    /* font-size: 0.875rem; */
    font-size: 0.75rem;
  }

  table.fluent tbody td {
    border-top: 1px solid #eaeaea;
    text-align: left;
    white-space: nowrap;
    & > div {
      padding: .375rem .5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
`;

